// extracted by mini-css-extract-plugin
export var customFont = "Testimonials-module--customFont--17e4e";
export var testimonialCard = "Testimonials-module--testimonialCard--4dec4";
export var userImage = "Testimonials-module--userImage--d8665";